import { ColumnSpan, ColumnSpanConfig } from "./GridColumn.types";
import { Breakpoint } from "../../config/setColumnSpan";

/**
 * The width that actually applies at a breakpoint: `mobile` defaults to full width and
 * `tablet` to the desktop span, so an author only sets what differs. `GridColumn`
 * renders by it and both width controls show it, so no panel can disagree with the page.
 */
export function effectiveSpan(
  span: ColumnSpanConfig | undefined,
  breakpoint: Breakpoint
): ColumnSpan {
  if (!span) {
    return 12;
  }

  if (breakpoint === "mobile") {
    return span.mobile ?? 12;
  }

  return breakpoint === "tablet" ? span.tablet ?? span.desktop : span.desktop;
}
